export default __webpack_public_path__ + "static/media/rect.20a7efc0.svg";